import React, { useCallback } from "react";
import styled from "styled-components";
import Info from "./Info";

const StyledMarker = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  border: 8px solid ${({ color }) => (color ? "#" + color : "#fff")};
  background-color: white;
  width: 8px;
  height: 8px;
  cursor: pointer;
  &::after {
    position: absolute;
    content: "";
    width: 0px;
    height: 0px;
    bottom: -30px;
    left: -6px;
    border: 10px solid transparent;
    border-top: 17px solid ${({ color }) => (color ? "#" + color : "#fff")};
  }
`;

function getCorrectColor(color) {
  return color?.charAt(0) === "#" ? color.substring(1) : color;
}

export default function Marker({
  zoomToPoint,
  markerColor,
  lat,
  lng,
  id,
  events,
  selectedCompany,
  infoDialogData,
  showInfoDialog,
  setShowInfoDialog,
  openInfo,
  setOpenInfo,
  channels,
  userMarker,
}) {
  const handleCLick = useCallback(
    e => {
      e.stopPropagation();
      setShowInfoDialog(id);
      zoomToPoint();
    },
    [id, setShowInfoDialog, zoomToPoint]
  );
  if (selectedCompany && showInfoDialog === null) {
    setShowInfoDialog(selectedCompany.id);
  }

  if (userMarker) {
    return (
      <svg
        width={46}
        height={46}
        viewBox="0 0 46 46 "
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx={23} cy={23} r={20} fill="#E08230" />
        <circle
          cx={23}
          cy={23}
          r={16.1667}
          stroke="white"
          strokeOpacity={0.5}
          strokeWidth={7.66667}
        />
      </svg>
    );
  }

  return (
    <StyledMarker
      color={events && events.length > 0 ? "000" : getCorrectColor(markerColor)}
      onClick={handleCLick}
      title={infoDialogData && infoDialogData.name}
      alt={infoDialogData && infoDialogData.name}
    >
      {showInfoDialog && showInfoDialog === id && (
        <Info
          setShowInfoDialog={setShowInfoDialog}
          openInfo={openInfo}
          setOpenInfo={setOpenInfo}
          markerColor={markerColor}
          markerPosition={{ lat, lng }}
          infoDialogData={infoDialogData}
          id={id}
          events={events}
          selectedCompany={selectedCompany}
          channels={channels}
        />
      )}
    </StyledMarker>
  );
}
